import {Component, Input, Output, EventEmitter} from '@angular/core';
import {TargetGroupAnalytics} from '../../models/target-group-analytics.model';

@Component({
  selector: 'leada-analytics-result',
  templateUrl: './analytics-result.component.html',
  styleUrls: ['./analytics-result.component.css']
})
export class AnalyticsResultComponent {
  @Input() analytics: TargetGroupAnalytics;
  @Output() exportCSV = new EventEmitter<void>();
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/export/components/analytics-result/analytics-result.component.ts